import React from 'react';
import { CtaButton } from '../CtaButton';
import { ProductImage } from '../ProductImage';
import { PriceBlock } from '../PriceBlock';
import { BRAND, PRODUCT_NAME } from '../../data/salesContent';
export function FinalCtaSection() {
  return <section className="border-t border-line bg-surface px-5 py-20 md:py-28" data-id="element-116" data-mp="2ik0yq7jl8krg">
      <div className="mx-auto max-w-3xl text-center" data-id="element-117" data-mp="2dibsd57b8v9p">
        <ProductImage className="mx-auto w-full max-w-xl" data-id="element-118" data-mp="2rj4k5i689c94" />
        <p className="mt-12 text-sm font-bold uppercase tracking-[0.25em] text-accent md:text-base" data-id="element-119" data-mp="2rhjrxz7dy5ef">{BRAND} presenta</p>
        <p className="mt-3 text-base font-extrabold uppercase tracking-[0.15em] text-muted md:text-lg" data-id="element-120" data-mp="2mhyrfkckhozl">{PRODUCT_NAME}</p>
        <h2 className="mt-5 text-4xl font-black uppercase leading-tight tracking-tight text-ink md:text-6xl" data-id="element-121" data-mp="2w9uu78plm3a5">
          Dejá de preparar cada charla <span className="text-accent" data-id="element-122" data-mp="3aafa9x44pkzy">desde cero.</span>
        </h2>
        <p className="mx-auto mt-6 max-w-2xl text-lg leading-relaxed text-muted md:text-xl" data-id="element-123" data-mp="368kawy5rdhot">
          Tené en un solo lugar las charlas, guiones, presentaciones, folletos, actividades y herramientas necesarias para organizar tus
          próximas actividades de educación para la salud.
        </p>
        <p className="mt-10 text-base font-extrabold uppercase tracking-widest text-ink md:text-lg" data-id="element-124" data-mp="2b0pz3bkq4ynx">5 volúmenes + 5 bonos</p>
        <div className="mt-2" data-id="element-125" data-mp="2g1dppw51jdhm">
          <PriceBlock data-id="element-126" data-mp="2fy9a82m4kvbn" />
        </div>
        <div className="mt-10" data-id="element-127" data-mp="2kzyodr4n9p3y">
          <CtaButton data-id="element-128" data-mp="2kynmjwurerfh">Quiero acceder al sistema completo</CtaButton>
        </div>
      </div>
    </section>;
}